var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus Icon Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5 0.85C8.86487 0.85 8.35 1.36487 8.35 2V18C8.35 18.6351 8.86487 19.15 9.5 19.15C10.1351 19.15 10.65 18.6351 10.65 18V2C10.65 1.36487 10.1351 0.85 9.5 0.85Z",
    fill: "#616874",
    stroke: "#616874",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 8.85C0.864873 8.85 0.35 9.36487 0.35 10C0.35 10.6351 0.864873 11.15 1.5 11.15H17.5C18.1351 11.15 18.65 10.6351 18.65 10C18.65 9.36487 18.1351 8.85 17.5 8.85H1.5Z",
    fill: "#616874",
    stroke: "#616874",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray);
export default __webpack_public_path__ + "static/media/plus-gray.fea3702f82b19bcfc37a21b66888e4a8.svg";
export { ForwardRef as ReactComponent };